import { JSONContent } from '@tiptap/core';

import { getMarkdownManager } from './markdownManager';

type MarkdownToTiptapJsonReturn =
  | { ok: true; result: JSONContent }
  | { ok: false; error: Error };

// Markdown → Tiptap JSON via the single @tiptap/markdown engine (ENG-4659).
// MarkdownManager.parse IS the editor's own markdown parser, so this produces the
// same document the editor would — replacing the prior marked → @tiptap/html
// pipeline. Paired with tiptapJsonToMarkdown for the reverse.
export const markdownToTiptapJson = ({
  markdown,
}: {
  markdown: string;
}): MarkdownToTiptapJsonReturn => {
  try {
    const result = getMarkdownManager().parse(markdown);

    return {
      ok: true,
      result,
    };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
};
